import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  FormGroup,
  Container,
  Grid,
  TextField,
  Typography,
  Link,
  CardContent,
  Card,
  Tooltip,
  Autocomplete,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import * as Yup from 'yup';
import './styles.css';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import { useStyles } from '../../components/Styles';
import GroupButton from '../../components/Buttons/ButtonGroup';
import NumberFormat from 'react-number-format';
import TextFieldCustom from '../../components/Inputs/TextField/TextField';
import DateField from '../../components/Inputs/Date/DateField';
import { TooltipInfo } from 'components/tooltips/tooltipsInfo';
import styleGlobal from '../../Global.module.css';
import InfoIcon from '@mui/icons-material/Info';
import { POND_STATUS_CYCLE } from 'utils/consts';
import { labelField } from 'utils';

function Mortality() {
  const location = useLocation();
  const [openProgress, setOpenProgress] = useState(false);
  const [pondCycles, setPondCycles] = useState([]);
  const [selectedPondCycle, handleSelectedPondCycle] = useState(null);
  const [cycleHasPond, setCycleHasPond] = useState(false);
  const [selectedDate, handleSelectedDate] = useState(new Date());
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle,
  );

  const disable = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();
  const history = useHistory();
  const dispatch = useDispatch();
  let { id } = useParams();
  const classes = useStyles();

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;

        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);
    formik.setFieldValue('cycle', data.cycle.id);
    handleSelectedPondCycle(data.cycle);
  }

  const formik = useFormik({
    initialValues: {
      cycle: '',
      qtd_estimated: '',
      cause: '',
      date: new Date(),
      observation: '',
    },
    validationSchema: Yup.object({
      cycle: Yup.number().required('Campo Obrigatório'),
      qtd_estimated: Yup.number()
        .required('Campo Obrigatório')
        .min(1, 'Precisa ser acima de 0')
        .max(
          selectedPondCycle ? selectedPondCycle.population : 9999999999,
          'Quantidade de animais no viveiro ultrapassado.',
        )
        .integer('O valor deve ser um número inteiro'),
      cause: Yup.string()
        .required('Campo Obrigatório')
        .max(50, 'Máximo de caracteres ultrapassado (50 caracteres).'),
      date: Yup.date()
        .required('Campo Obrigatório')
        .typeError('Data invalida')
        .nullable(),
      observation: Yup.string().max(
        100,
        'Máximo de caracteres ultrapassado (100 caracteres).',
      ),
    }),
    onSubmit: (values) => {
      // values.date = moment(values.date).format("YYYY-MM-DDT00:00:00[Z]");
      dispatch(setDisable(true));
      dispatch(setLoading(true));
      values.cycle = selectedPondCycle.id;
      request(values);
    },
  });

  useEffect(() => {
    api.get(`/cycles/cycle-code/${selectedCycle.id}`).then((pondCycles_) => {
      pondCycles_.data.length > 0 && setCycleHasPond(true);
      setPondCycles(
        pondCycles_.data.filter((pond) => pond.status === POND_STATUS_CYCLE.CULTIVANDO),
      );
    });
  }, [selectedCycle]);

  async function request(data) {
    // envia os dados para api salvar no banco
    try {
      id
        ? await api.put(`/mortalities/${id}`, { ...data })
        : await api.post('/mortalities', { ...data });
      success();
      history.push('/mortalities');
    } catch (err) {
      error();
      console.error(err);
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  // Estilização do tooltip
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <header className={styleGlobal.headerGlobal}>
      {openProgress ? <Progress /> : null}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem' }}>
              Dados de Mortalidade
              {' '}
              <HtmlTooltip
                title={(
                  <>
                    Nessa tela é possível cadastrar ou editar a mortalidade dos animais de um viveiro. Essa informação será usada para calcular a sobrevivência de um viveiro ou do ciclo.
                  </>
                )}
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>
            <CardContent style={{ padding: '0rem' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormGroup>
                    <Autocomplete
                      noOptionsText="Não existe viveiros com mortalidade"
                      // noOptionsText={
                      //   <Typography>
                      //     {cycleHasPond
                      //       ? "Para informar mortalidade é necessário que o viveiro já esteja povoado."
                      //       : "Nenhum viveiro configurado para esse ciclo."}
                      //     <Link
                      //       style={{ marginLeft: "1%", cursor: "pointer" }}
                      //       color="primary"
                      //       underline="none"
                      //       onMouseDown={() => {
                      //         cycleHasPond
                      //           ? history.push("/populations")
                      //           : history.push("/cycles");
                      //       }}
                      //     >
                      //       Configurar agora +
                      //     </Link>
                      //   </Typography>
                      // }
                      name="cycle"
                      options={pondCycles}
                      value={selectedPondCycle}
                      getOptionLabel={(options) => options.pond.description}
                      onChange={(p, v) => {
                        handleSelectedPondCycle(v);
                        formik.values.cycle = v.id;
                      }}
                      disableClearable
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={labelField('Viveiro')}
                          variant="outlined"
                          onBlur={formik.handleBlur}
                          error={formik.touched.cycle && formik.errors.cycle}
                          helperText={
                            formik.touched.cycle && formik.errors.cycle
                          }
                        />
                      )}
                    />
                  </FormGroup>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormGroup>
                    <NumberFormat
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="qtd_estimated"
                      name="qtd_estimated"
                      required={formik.values.qtd_estimated > 0}
                      inputProps={{
                        min: 1,
                      }}
                      variant="outlined"
                      thousandSeparator="."
                      decimalSeparator=","
                      isNumericString
                      allowNegative={false}
                      decimalScale={0}
                      fullWidth
                      label={labelField('Quantidade de animais')}
                      customInput={TextField}
                      value={formik.values.qtd_estimated}
                      errorAndHelper="qtd_estimated"
                      error={
                        formik.touched.qtd_estimated
                        && formik.errors.qtd_estimated
                      }
                      onBlur={formik.handleBlur}
                      helperText={
                        formik.touched.qtd_estimated
                        && formik.errors.qtd_estimated
                      }
                      onValueChange={(values) => {
                        formik.setValues({
                          ...formik.values,
                          qtd_estimated: parseInt(values.value) | 0,
                        });
                      }}
                    />
                  </FormGroup>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormGroup>
                    <DateField
                      name="Data"
                      formik={formik}
                      value={formik.values.date}
                      onChange={(date) => {
                        handleSelectedDate(date);
                        formik.setFieldValue('date', date);
                      }}
                      format="dd/MM/yyyy"
                    />
                  </FormGroup>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <TextFieldCustom
                    id="causa"
                    label={labelField('Causa')}
                    formik={formik}
                    value={formik.values.cause}
                    onChange={(e) => formik.setFieldValue('cause', e.target.value)}
                    onBlur={formik.handleBlur}
                    errorAndHelper="cause"
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <TextFieldCustom
                    maxlength="100"
                    id="observation"
                    label="Observação (Opcional)"
                    formik={formik}
                    value={formik.values.observation}
                    onBlur={formik.handleBlur}
                    onChange={(e) => formik.setFieldValue('observation', e.target.value)}
                    errorAndHelper="observation"
                    error={
                      formik.touched.observation && formik.errors.observation
                    }
                    helperText={
                      formik.touched.observation && formik.errors.observation
                    }
                  />
                </Grid>
              </Grid>
            </CardContent>
          </div>

          <GroupButton
            deleteRoute="/mortalities/"
            routeDelete="/mortalities"
            returnRoute="/mortalities"
            id={id}
            disable={disable}
            message="A exclusão dessa mortalidade pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
          />
        </form>
      </Card>
    </header>
  );
}

export default Mortality;
